import http from "../../../core/utils/apis/api";

const getTrainings = async (options) => {
    try {
        const response = await http({
            method: "GET",
            url: `/trainings`,
            params: options,
        });
        return response;
    } catch (e) {
        throw e;
    }
};

const trainingHistoryService = {
    getTrainings,
};

export default trainingHistoryService;
